import React, { useEffect, useState } from "react";
import {
  Button, Card, CardBody, Col, Container, Row, Modal, ModalBody, ModalHeader,
  Form, Label, Input, Nav, NavItem, NavLink, Spinner, Alert, Badge
} from "reactstrap";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from '@fullcalendar/list';
import interactionPlugin from "@fullcalendar/interaction"; 
import trLocale from '@fullcalendar/core/locales/tr'; 

import Breadcrumbs from "../../components/Common/Breadcrumb";
import { ToastContainer, toast } from "react-toastify";

const Musaitligim = () => {
  document.title = "Müsaitlik Takvimi | HarmanaGEL";

  // --- ROL VE YETKİ KONTROLÜ ---
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const loggedInUserId = authUser?.ID;
  const isAdmin = authUser?.HESAP_TURU === 'Admin';

  // --- STATE YÖNETİMİ ---
  const [availabilities, setAvailabilities] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  
  // Admin için kullanıcı listesi ve seçili kullanıcı
  const [userList, setUserList] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(isAdmin ? "" : loggedInUserId);

  // Modal State'leri
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedEventId, setSelectedEventId] = useState(null);
  
  const [formData, setFormData] = useState({
    startDate: "", endDate: "", startTime: "08:00", endTime: "18:00"
  });

  const toggleModal = () => {
    setModal(!modal);
    if (modal) {
      setFormData({ startDate: "", endDate: "", startTime: "08:00", endTime: "18:00" });
      setIsEdit(false);
      setSelectedEventId(null);
    }
  };

  // --- 1. ADMİN İSE KULLANICI LİSTESİNİ ÇEK ---
  useEffect(() => {
    if (isAdmin) {
      const fetchUsers = async () => {
        try {
          const response = await fetch("https://harmanagelapi.stechomeyazilim.info/KULLANICILAR?$select=ID,AD_SOYAD&$filter=AKTIF_DURUM eq true");
          const result = await response.json();
          if (result && result.value) {
            setUserList(result.value);
            // Varsayılan olarak listedeki ilk kullanıcıyı seç
            if (result.value.length > 0) setSelectedUserId(result.value[0].ID);
          }
        } catch (error) {
          toast.error("Kullanıcı listesi alınamadı.");
        }
      };
      fetchUsers();
    }
  }, [isAdmin]);

  // --- 2. SEÇİLİ KULLANICININ TAKVİMİNİ ÇEK ---
  const fetchAvailabilities = async () => {
    if (!selectedUserId) return; // Kullanıcı seçilmediyse bekle
    setIsLoading(true);
    try {
      const response = await fetch(`https://harmanagelapi.stechomeyazilim.info/KULLANICI_MUSAITLIK?$filter=KULLANICI_ID eq ${selectedUserId}`);
      const result = await response.json();

      if (result && result.value) {
        const formattedEvents = result.value.map(item => ({
          id: item.ID,
          title: "Müsait",
          start: item.Start_DateTime,
          end: item.End_DateTime,
          className: "bg-success text-white border-success",
          allDay: false
        }));
        setAvailabilities(formattedEvents);
      } else {
        setAvailabilities([]); // Veri yoksa takvimi temizle
      }
    } catch (error) {
      toast.error("Müsaitlik takvimi yüklenemedi.");
    } finally {
      setIsLoading(false);
    }
  };

  // selectedUserId her değiştiğinde takvimi yenile
  useEffect(() => {
    fetchAvailabilities();
  }, [selectedUserId]);

  // --- TAKVİM AKSİYONLARI ---
  const handleDateSelect = (arg) => {
    let startDateStr = arg.startStr.split('T')[0];
    let endDateStr = arg.endStr.split('T')[0];
    let startTimeStr = "08:00"; 
    let endTimeStr = "18:00";   

    if (arg.allDay) {
      const exclusiveEnd = new Date(arg.end);
      exclusiveEnd.setDate(exclusiveEnd.getDate() - 1);
      endDateStr = exclusiveEnd.toISOString().split('T')[0];
    } else {
      startTimeStr = arg.startStr.split('T')[1].substring(0, 5);
      endTimeStr = arg.endStr.split('T')[1].substring(0, 5);
    }

    setFormData({ startDate: startDateStr, endDate: endDateStr, startTime: startTimeStr, endTime: endTimeStr });
    setIsEdit(false);
    setModal(true);
  };

  const handleEventClick = (arg) => {
    const event = arg.event;
    const startObj = new Date(event.start);
    const endObj = event.end ? new Date(event.end) : startObj;

    setFormData({
      startDate: startObj.toISOString().split('T')[0],
      endDate: endObj.toISOString().split('T')[0],
      startTime: startObj.toTimeString().substring(0, 5),
      endTime: endObj.toTimeString().substring(0, 5)
    });
    setSelectedEventId(event.id);
    setIsEdit(true);
    setModal(true);
  };

  // --- KAYDET / GÜNCELLE / SİL ---
  const handleSave = async (e) => {
    e.preventDefault();
    if (!selectedUserId) {
      toast.warning("Lütfen işlem yapılacak kullanıcıyı seçin.");
      return;
    }

    const startDateTime = `${formData.startDate}T${formData.startTime}:00Z`;
    const endDateTime = `${formData.endDate}T${formData.endTime}:00Z`;

    const payload = {
      Users_ID: selectedUserId, // İşlem her zaman seçili kullanıcıya (Admin ise listeye, Sürücü ise kendine) yapılır
      Start_DateTime: startDateTime,
      End_DateTime: endDateTime
    };

    try {
      const url = isEdit 
        ? `https://harmanagelapi.stechomeyazilim.info/KULLANICI_MUSAITLIK(${selectedEventId})` 
        : `https://harmanagelapi.stechomeyazilim.info/KULLANICI_MUSAITLIK`;
      
      const response = await fetch(url, {
        method: isEdit ? 'PUT' : 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if(response.ok) {
          toast.success("Takvim başarıyla güncellendi.");
          fetchAvailabilities(); 
          toggleModal();
      }
    } catch (error) {
      toast.error("İşlem sırasında hata oluştu.");
    }
  };

  const handleDelete = async () => {
    if (!selectedEventId) return;
    try {
      await fetch(`https://harmanagelapi.stechomeyazilim.info/KULLANICI_MUSAITLIK(${selectedEventId})`, { method: 'DELETE' });
      toast.success("Müsaitlik silindi.");
      fetchAvailabilities(); 
      toggleModal();
    } catch (error) {
      toast.error("Silme işlemi başarısız.");
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Operasyon" breadcrumbItem="Takvim Yönetimi" />
          
          <div className="d-flex justify-content-between align-items-center mb-4">
              <h2 className="mb-0">Müsaitlik Takvimi</h2>
              <Button color="light" size="sm" className="text-primary border-primary bg-transparent fw-medium">
                  <i className="mdi mdi-help-circle-outline me-1"></i> Nasıl kullanılır?
              </Button>
          </div>

          {/* SADECE ADMİN İSE GÖRÜNEN KULLANICI SEÇİM ALANI */}
          {isAdmin && (
            <Alert color="primary" className="d-flex align-items-center justify-content-between border-0 shadow-sm mb-4">
              <div className="d-flex align-items-center">
                <i className="mdi mdi-account-search fs-3 me-3"></i>
                <div>
                  <h6 className="mb-0">Yönetici Modu Devrede</h6>
                  <p className="mb-0 small">Müsaitlik takvimini düzenlemek istediğiniz sürücüyü seçin.</p>
                </div>
              </div>
              <div style={{ minWidth: "250px" }}>
                <Input 
                  type="select" 
                  className="form-select-lg fw-bold text-primary"
                  value={selectedUserId} 
                  onChange={(e) => setSelectedUserId(e.target.value)}
                >
                  <option value="" disabled>Kullanıcı Seçiniz...</option>
                  {userList.map(user => (
                    <option key={user.ID} value={user.ID}>{user.AD_SOYAD}</option>
                  ))}
                </Input>
              </div>
            </Alert>
          )}

          <Row>
            <Col xs={12}>
              <Card className="shadow-sm">
                <CardBody className="pt-0 pb-0 border-bottom bg-light bg-opacity-50">
                  <Nav tabs className="nav-tabs-custom">
                    <NavItem>
                      <NavLink className="active fw-medium text-dark" style={{cursor:'pointer'}}>
                        {isAdmin ? "Seçili Sürücünün Takvimi" : "Benim Takvimim"}
                      </NavLink>
                    </NavItem>
                  </Nav>
                </CardBody>

                <CardBody>
                  {isLoading ? (
                    <div className="text-center py-5"><Spinner color="primary"/></div>
                  ) : !selectedUserId ? (
                    <div className="text-center py-5 text-muted">
                        <i className="bx bx-calendar-x display-4 mb-3"></i>
                        <h5>Lütfen takvimini görüntülemek için bir kullanıcı seçin.</h5>
                    </div>
                  ) : (
                    <FullCalendar
                      plugins={[dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin]}
                      initialView="dayGridMonth"
                      themeSystem="bootstrap5"
                      headerToolbar={{
                        left: "prev,next customAddButton",
                        center: "title",
                        right: "dayGridMonth,timeGridWeek,listWeek",
                      }}
                      customButtons={{
                        customAddButton: {
                          text: 'Müsaitlik Ekle',
                          click: () => {
                            setFormData({ startDate: "", endDate: "", startTime: "08:00", endTime: "18:00" });
                            setIsEdit(false);
                            setModal(true);
                          }
                        }
                      }}
                      buttonText={{ month: 'Ay', week: 'Hafta', list: 'Liste' }}
                      locale={trLocale} 
                      events={availabilities}
                      selectable={true}        
                      selectMirror={true}      
                      unselectAuto={true}      
                      select={handleDateSelect}
                      eventClick={handleEventClick}
                      height="auto"
                    />
                  )}
                </CardBody>
              </Card>

              {/* Müsaitlik Ekleme Modalı */}
              <Modal isOpen={modal} toggle={toggleModal} centered>
                <ModalHeader toggle={toggleModal} className="bg-primary text-white border-bottom-0 pb-3">
                  <h5 className="modal-title w-100 fw-bold">
                    {isEdit ? "Müsaitlik Saatlerini Düzenle" : "Yeni Müsaitlik Oluştur"}
                  </h5>
                </ModalHeader>
                <ModalBody className="p-4 bg-light">
                  <Form onSubmit={handleSave}>
                    <Row className="mb-4">
                        <Col md={6}>
                            <Label className="fw-medium">Başlangıç Tarihi:</Label>
                            <Input type="date" required value={formData.startDate} onChange={(e) => setFormData({...formData, startDate: e.target.value})} />
                        </Col>
                        <Col md={6}>
                            <Label className="fw-medium">Bitiş Tarihi:</Label>
                            <Input type="date" required value={formData.endDate} onChange={(e) => setFormData({...formData, endDate: e.target.value})} />
                        </Col>
                    </Row>
                    <Row className="mb-4">
                      <Col md={6}>
                        <Label className="fw-medium">Başlangıç Saati:</Label>
                        <Input type="time" required value={formData.startTime} onChange={(e) => setFormData({...formData, startTime: e.target.value})} />
                      </Col>
                      <Col md={6}>
                        <Label className="fw-medium">Bitiş Saati:</Label>
                        <Input type="time" required value={formData.endTime} onChange={(e) => setFormData({...formData, endTime: e.target.value})} />
                      </Col>
                    </Row>

                    <div className="d-flex justify-content-end gap-2 mt-4 pt-3 border-top">
                      <Button color="secondary" type="button" onClick={toggleModal}>İptal</Button>
                      {isEdit && <Button color="danger" type="button" onClick={handleDelete}><i className="mdi mdi-delete"></i> Sil</Button>}
                      <Button color="success" type="submit" disabled={isLoading} className="d-flex align-items-center">
                        {isEdit ? "Güncelle" : "Kaydet"} <i className="mdi mdi-check ms-1"></i>
                      </Button>
                    </div>
                  </Form>
                </ModalBody>
              </Modal>

            </Col>
          </Row>
        </Container>
      </div>
      <ToastContainer autoClose={2000} />
    </React.Fragment>
  );
};

export default Musaitligim;